import axios from "axios";
import redirectInterceptor from "@/interceptors/redirect_interceptor";
import { getConfig } from "@/config";

import { onConfig } from "@/config";

let config = null;
onConfig((c) => {
  config = c;
});

export async function getVesselsDashboard() {
  if (config.VUE_APP_COMPANY_ID === "4") {
    const response = await axios.get("/fleetDashboard.json");
    return response.data.data;
  }

  const basicUrl = getConfig().VUE_APP_BASIC_URL;

  const response = await redirectInterceptor.get(`${basicUrl}/home2`, {
    headers: {
      Authorization: localStorage.getItem("quad_token"),
    },
  });

  if (response.data.success) {
    return response.data.data;
  }

  const error = new Error(response.data.msg || "Failed to fetch vessels");
  error.code = response.data.msg;
  throw error;
}
